import { render, staticRenderFns } from "./zhiyiiDialog.vue?vue&type=template&id=662fbe23&"
import script from "./zhiyiiDialog.vue?vue&type=script&lang=ts&"
export * from "./zhiyiiDialog.vue?vue&type=script&lang=ts&"
import style0 from "./zhiyiiDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports